import { invoke } from '@shared/easyfy.decorators';
import Events, { ServiceNames } from '@shared/easyfy.events/easyfy.eventhandler';
import { Ga4DataMapper } from '@clientWebModules/eventMappers/dataMapper.ga4';
import { StatsDataMapper } from '@shared/easyfy.events/mappers/dataMapper.stats';
import { KlaviyoDataMapper } from '@shared/easyfy.events/mappers/dataMapper.klaviyo';
import { IDataMapper } from '@shared/easyfy.events/easyfy.eventdata';
import Search, { SearchConfig } from '@webModules/search';
import '@clientWebModules/header';
import '@clientWebModules/dropdown';
import '@clientShared/toggle';
import '@clientShared/form';
import '@clientShared/logout';
import AgeGate from '@clientWebModules/agegate';
import { OptionSelector } from '@clientWebModules/optionselector';
import SubscriptionHelper from '@clientShared/subscriptionHelper';
import CountryPopup from '@clientWebModules/countrypopup';

@invoke
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class Global {
  constructor() {
    new Search.Search(new SearchConfig(3, 'grid')).OnInit();
    new Events.EasyfyEventHandler(
      new Map<string, IDataMapper>([
        [ServiceNames.Ga4, new Ga4DataMapper()],
        [ServiceNames.Stats, new StatsDataMapper()],
        [ServiceNames.Klaviyo, new KlaviyoDataMapper()],
      ])
    );
    new AgeGate();
    new CountryPopup();
    new SubscriptionHelper();

    OptionSelector;
  }
}
